import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { StoreCard } from "../stores/StoreCard";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const FALLBACK = {
  id: "nirvana-tcg-oficial",
  nombre: "Nirvana TCG",
  logo_url: "/logo-nirvana.png",
  direccion_texto: "Av. San Martín, Edificio Promarca, Piso 2, Caracas",
  ciudad: "Caracas",
  estatus: "Oficial",
  maps_url: "https://maps.app.goo.gl/zCuVUBVQPMAK4vEv9",
  embed_url: "https://maps.google.com/maps?q=10.4974782,-66.9279791&z=16&output=embed",
  whatsapp: "584129953694",
  whatsapp_url: "https://wa.me/584129953694",
  whatsapp2: "584168688655",
  whatsapp2_url: "https://wa.me/584168688655",
  instagram_url: "https://instagram.com/nirvanatcg.ve",
  facebook: "https://www.facebook.com/profile.php?id=61589174192338",
};

const LocationSection = () => {
  const [store, setStore] = useState(FALLBACK);
  useEffect(() => { axios.get(`${API}/stores/official`).then((r) => setStore(r.data)).catch(() => {}); }, []);

  return (
    <section className="relative py-16 md:py-24 bg-gradient-to-b from-black via-[#07051a] to-black overflow-hidden" data-testid="location-section">
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-cyan-400/40 to-transparent" />
      <div className="absolute -left-40 top-1/3 w-96 h-96 rounded-full bg-purple-600/10 blur-3xl pointer-events-none" />
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-[1fr_1.1fr] gap-10 items-center">
          <div>
            <p className="text-xs tracking-[0.3em] text-cyan-400 font-bold mb-3">VISÍTANOS</p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black mb-4 leading-tight">
              <span className="bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-500 bg-clip-text text-transparent">Nuestra tienda oficial</span>
            </h2>
            <p className="text-gray-400 text-sm md:text-base mb-6 max-w-lg">Sede de las ligas y torneos del circuito Nirvana. Horarios, reseñas y fotos siempre actualizados en Google Maps. Escríbenos por WhatsApp para reservar tu cupo o consultar producto.</p>
            <ul className="space-y-3 text-sm text-gray-300 mb-8">
              <li className="flex items-center gap-3"><span className="w-2 h-2 rounded-full bg-cyan-400 shadow-[0_0_10px_rgba(34,211,238,0.8)]" /> Torneos semanales de Yu-Gi-Oh! en todos los formatos</li>
              <li className="flex items-center gap-3"><span className="w-2 h-2 rounded-full bg-pink-400 shadow-[0_0_10px_rgba(244,114,182,0.8)]" /> Producto sellado, singles y accesorios</li>
              <li className="flex items-center gap-3"><span className="w-2 h-2 rounded-full bg-yellow-400 shadow-[0_0_10px_rgba(250,204,21,0.8)]" /> Puntos válidos para el Ranking Anual Nirvana</li>
            </ul>
            <Link to="/tiendas" className="inline-flex items-center gap-2 px-5 py-3 rounded-xl border border-purple-500/50 text-purple-200 font-semibold hover:bg-purple-500/20 transition" data-testid="home-all-stores-link">Ver página de la tienda →</Link>
          </div>
          <StoreCard store={store} large />
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
